import React, { useEffect, useState } from 'react';
import {
  deleteTrainingCenterAction,
  getTrainingCentersAction,
  switchTrainingCenterAction
} from '../../../modules/trainingCenter/Actions';
import {
  // supplierCategoriesListSelector,
  // isLoadingSelector,
  // searchValueSelector,
  // countSelector,
  trainingCenterAsListAndValue,
  trainingCenterCount,
  trainingCenterLoading,
  trainingCenterSearchValue
} from '../../../modules/trainingCenter/Selectors';
import { connect } from 'react-redux';
import List from '../../../components/Lists/List';
import ListItem from '../../../components/Lists/ListItem';
import InfiniteScroll from 'react-infinite-scroll-component';
import { authCurrentDefaultTypeSelecetor } from '../../../modules/auth/Selectors';
import getLangData from '../../../utils/getLangData';
import langText from '../../../utils/langText';
const TrainingCenterList = props => {
  const {
    // supplierCategories,
    // isLoading,
    // getSupplierCategories,
    // count,
    // searchValue,
    trainigCenter,
    count,
    isLoading,
    searchValue,
    getTrainingCenter,
    deteteTrainingCenter,
    defaultUserType,
    switchTrainingCenter
  } = props;

  const [size, setSize] = useState(10);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    getTrainingCenter({ size, offset, searchTerm: searchValue });
  }, [getTrainingCenter, searchValue]);

  const fetchMore = () => {
    // set hasMore to false if the current items are >= the all items in database !
    if (trainigCenter.length >= count) {
      setHasMore(false);
      return false;
    }

    // otherwise get the data from the database
    getTrainingCenter({
      size,
      offset: trainigCenter.length,
      searchTerm: searchValue
    });
  };

  //
  const dataLength =
    trainigCenter.length <= count ? trainigCenter.length : count;

  return (
    <InfiniteScroll
      dataLength={dataLength}
      hasMore={hasMore}
      next={fetchMore}
      style={{ overflow: 'hidden' }}
    >
      <div className='table row block--container my-5'>
        <List
          header={{ items: [getLangData().fields.name], actions: ['Edit'] }}
          isLoading={isLoading}
          items={trainigCenter}
        >
          <table className='table'>
            <tbody>
              {trainigCenter.map(
                ({ businessName, businessNamei18n, _id, status }) => (
                  <ListItem
                    key={_id}
                    name={langText(
                      businessName,
                      businessNamei18n,
                      getLangData().lang_code
                    )}
                    editLink={`/training-center/${_id}`}
                    enable={status}
                    onSwich={() => {
                      switchTrainingCenter(_id, { status: !status });
                    }}
                    viewCourseLink={`training-center/${_id}/course`}
                    onDelete={
                      defaultUserType === '0'
                        ? () => {
                            deteteTrainingCenter(_id);
                          }
                        : false
                    }
                  />
                )
              )}
            </tbody>
          </table>
        </List>
      </div>
    </InfiniteScroll>
  );
};

const mapStateToProps = state => ({
  // supplierCategories: supplierCategoriesListSelector(state),
  // isLoading: isLoadingSelector(state),
  // count: countSelector(state),
  // searchValue: searchValueSelector(state),
  trainigCenter: trainingCenterAsListAndValue(state),
  count: trainingCenterCount(state),
  isLoading: trainingCenterLoading(state),
  searchValue: trainingCenterSearchValue(state),
  defaultUserType: authCurrentDefaultTypeSelecetor(state)
});

export default connect(mapStateToProps, {
  // getSupplierCategories: getSupplierCategoriesAction,
  switchTrainingCenter: switchTrainingCenterAction,
  getTrainingCenter: getTrainingCentersAction,
  deteteTrainingCenter: deleteTrainingCenterAction
})(TrainingCenterList);
